export default function Maintenance() {
  return (
    <div style={{width: '100%', height: window.innerHeight, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
      <h1>This Page is Under Maintenance</h1>
      <h1>Check Back Later</h1>
    </div>
  );
}